import { t } from '../i18n/lingua'

/**
 * Come si collega Jira, e dove si trovano in Jira le cose che il modulo
 * chiede: accanto al modulo del connettore, chiusa di default. Chi configura
 * Jira per la prima volta di solito non sa dove si crea un API token né che
 * cosa sia uno schema di Assets, e la domanda nasce proprio qui.
 * Stesso testo, più esteso, in docs/operations/jira-assets.md.
 */
export function GuidaJira() {
  return (
    <details className="guida-chiave">
      <summary>{t('Come collego Jira, e dove trovo le cose?')}</summary>
      <div className="guida-chiave__corpo">
        <p>
          {t(
            'Il connettore scrive nella CMDB di Jira, cioè Jira Service Management Assets, non nei ticket. Servono Jira Service Management con Assets attivo e un’utenza che veda gli schemi da sincronizzare.',
          )}
        </p>

        <h4>{t('A) Jira Cloud')}</h4>
        <ol>
          <li>
            {t(
              'Indirizzo: il sito, per esempio https://azienda.atlassian.net, senza percorsi. Installazione: cloud.',
            )}
          </li>
          <li>
            {t(
              'Utenza: meglio una dedicata, con licenza agente di Jira Service Management. In Assets apri lo schema → Impostazioni dello schema → Ruoli e dalle il ruolo «Object Schema Users» per leggere, o «Object Schema Managers» per scrivere.',
            )}
          </li>
          <li>
            {t(
              'API token: entra con quell’utenza su id.atlassian.com/manage-profile/security/api-tokens → «Crea token API», dagli un nome (per esempio CENSO) e una scadenza, e copialo subito: non si rivede. Nel connettore vanno l’email dell’utenza e il token.',
            )}
          </li>
          <li>
            {t(
              'Attenzione a non confondere il token personale, che comincia con ATATT e si crea su id.atlassian.com, con le API key dell’organizzazione, che cominciano con ATCTT e si creano in admin.atlassian.com: queste non valgono per Jira né per Assets, e CENSO lo dice subito.',
            )}
          </li>
          <li>
            {t(
              'Token con o senza ambiti: vanno bene entrambi. Il più semplice è «Crea token API» (senza ambiti). Se usi «Crea token API con ambiti», scegli l’app Jira e dagli almeno read:jira-user e gli ambiti di Assets read:cmdb-schema:jira, read:cmdb-type:jira, read:cmdb-attribute:jira, read:cmdb-object:jira (più write:cmdb-object:jira per scrivere): CENSO lo usa passando da api.atlassian.com.',
            )}
          </li>
          <li>
            {t(
              'Workspace: di norma lascialo vuoto, CENSO lo ricava dal sito. Se il sito ne ha più d’uno, lo trovi aprendo nel browser https://azienda.atlassian.net/rest/servicedeskapi/assets/workspace (campo workspaceId).',
            )}
          </li>
        </ol>

        <h4>{t('B) Jira Data Center')}</h4>
        <ol>
          <li>
            {t(
              'Indirizzo: quello di Jira, per esempio https://jira.azienda.local. Installazione: datacenter.',
            )}
          </li>
          <li>
            {t(
              'Utenza: con un ruolo sugli schemi di Assets, come per Cloud («Object Schema Users» o «Object Schema Managers»).',
            )}
          </li>
          <li>
            {t(
              'Personal Access Token: con quell’utenza, avatar in alto a destra → Profilo → Personal Access Tokens → «Create token»; imposta una scadenza e copialo subito. Serve Jira 8.14 o successivo.',
            )}
          </li>
          <li>
            {t(
              'Se Jira non è raggiungibile dal Control Plane, scegli qui sopra di passare da una sonda che lo raggiunge.',
            )}
          </li>
        </ol>

        <h4>{t('C) Dove trovare le cose in Assets')}</h4>
        <ul>
          <li>
            {t(
              'Schema gestito da CENSO (la scelta automatica della mappatura): indica nel connettore il nome dello schema. Se è uno schema che esiste già, CENSO riusa i suoi tipi (Server, Virtual Machines, Network Devices…) e i suoi attributi con nomi equivalenti, e crea solo quelli che mancano; se non esiste, lo crea. Creare uno schema richiede un amministratore di Jira o di Assets; se lo crei tu a mano, a CENSO basta il ruolo «Object Schema Managers» su quello schema.',
            )}
          </li>
          <li>
            {t(
              'Schemi e tipi di oggetto: menu Assets → Schemi di oggetti; dentro uno schema, a sinistra, l’albero dei tipi (Server, Computer…). Nella scansione del connettore compaiono come «Schema / Tipo».',
            )}
          </li>
          <li>
            {t(
              'L’ID di un tipo: aprendo il tipo, nell’indirizzo della pagina compare typeId=23. È la chiave con cui il connettore lo indica.',
            )}
          </li>
          <li>
            {t(
              'Gli attributi: nel tipo di oggetto, scheda Attributi. Sono i campi del mapping; «Name» è l’etichetta dell’oggetto, «Key» (per esempio CMDB-12) la assegna Jira e non si scrive.',
            )}
          </li>
          <li>
            {t(
              'Chiave di corrispondenza: scegli un attributo univoco e sempre valorizzato, come il numero di serie o l’hostname. Se lo stesso valore compare in due oggetti, il connettore si ferma invece di aggiornarne uno a caso.',
            )}
          </li>
          <li>
            {t(
              'Prima verifica: «Prova il collegamento» mostra l’utenza e quanti schemi vede. Zero schemi vuol dire che all’utenza manca un ruolo in Assets.',
            )}
          </li>
        </ul>
      </div>
    </details>
  )
}
